import { createSelector } from 'reselect';
import { VasState } from '../../store/store-type';

const getState = (state: VasState) => state.jobStatus;
const getActiveAccountId = (state: VasState) => state.account.selected;

export const getIds = createSelector(getState, state => state.ids);
export const getEntities = createSelector(getState, state => state.entities);

export const getAll = createSelector(
    getIds,
    getEntities,
    getActiveAccountId,
    (ids, entities, accountId) => {
        return ids
            .map(id => entities[id])
            .filter(jobStatus => jobStatus.account === accountId);
    }
);



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-status/job-status.selectors.ts